"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var getProp_1 = require("../getProp");

function comparePrimitive(content, anotherContent, property, path) {
  return {
    type: 'M',
    path: path.concat([property]),
    serializedPath: path.concat([property]).join('.'),
    originalContent: content,
    content: anotherContent
  };
}

function compareUndefined(content, side, path, property) {
  return {
    type: side === 'L' ? 'R' : 'A',
    path: path.concat([property]),
    serializedPath: path.concat([property]).join('.'),
    originalContent: side === 'L' ? content : undefined,
    content: side === 'L' ? undefined : content
  };
}

function pushUnmodified(content, path, property) {
  return {
    type: 'U',
    path: path.concat([property]),
    serializedPath: path.concat([property]).join('.'),
    originalContent: content,
    content: content
  };
}

function compareArrayItems(array, anotherArray, side, path) {
  return array.reduce(function (acc, item, i) {
    // ak sa obsah na indexoch rovna, nezaznamename ziadnu zmenu
    if (item === anotherArray[i]) {
      return side === 'L' ? acc.concat([pushUnmodified(item, path, i)]) : acc;
    } // ak v druhom pole na rovnakom indexe neexistuje content
    // tak zaznamename zmazanie, resp. pridanie (podla toho, ktore pole porovnavame)


    if (typeof anotherArray[i] === 'undefined') {
      return acc.concat([compareUndefined(item, side, path, i)]);
    } // ak ide o pole alebo objekt, tak budeme porovnavat ich indexy, resp. properties


    if (typeof item === 'object') {
      var deepChange = [];

      if (Array.isArray(item)) {
        deepChange = compareArrayItems(item, anotherArray[i], side, path.concat([i]));
      } else {
        deepChange = compareObjectProperties(item, anotherArray[i], side, path.concat([i]));
      }

      return acc.concat(deepChange);
    } // ak je obsahom property string, number alebo boolean (primitivne typy), porovnavame ich
    else if (['string', 'number', 'boolean'].indexOf(typeof item) > -1 && side === 'L') {
        return acc.concat([comparePrimitive(item, anotherArray[i], i, path)]);
      }

    return side === 'L' ? acc.concat([pushUnmodified(item, path, i)]) : acc;
  }, []);
}

function compareObjectProperties(object, anotherObject, side, path) {
  if (side === void 0) {
    side = 'L';
  }

  if (path === void 0) {
    path = [];
  }

  return Object.keys(object).reduce(function (acc, property) {
    if (typeof object[property] !== 'undefined' && typeof anotherObject[property] !== 'undefined' && object[property] === anotherObject[property]) {
      return side === 'L' ? acc.concat([pushUnmodified(object[property], path, property)]) : acc;
    } // ak v druhom objekte v rovnakej proeprty neexistuje content
    // tak zaznamename zmazanie, resp. pridanie (podla toho, ktory objekt porovnavame)


    if (typeof anotherObject[property] === 'undefined') {
      return acc.concat([compareUndefined(object[property], side, path, property)]);
    } // ak je obsahom property objekt alebo array


    if (typeof getProp_1.default(object, [property]) === 'object') {
      // dalsi deep compare pola
      if (Array.isArray(object[property])) {
        var deepChange = compareArrayItems(getProp_1.default(object, [property]), getProp_1.default(anotherObject, [property]), side, path.concat([property]));
        return acc.concat(deepChange);
      } // dalsi deep compare objektu
      else {
          var deepChange = compareObjectProperties(getProp_1.default(object, [property]), getProp_1.default(anotherObject, [property]), side, path.concat([property]));
          return acc.concat(deepChange);
        }
    } // ak je obsahom property string, number alebo boolean (primitivne typy)
    else if (['string', 'number', 'boolean'].indexOf(typeof getProp_1.default(object, [property])) > -1 && side === 'L') {
        return acc.concat([comparePrimitive(object[property], anotherObject[property], property, path)]);
      }

    return side === 'L' ? acc.concat([pushUnmodified(object[property], path, property)]) : acc;
  }, []);
}
/**
 * Utilitná funkcia pre získanie porovnanie objektov alebo polí
 * @param {Object | any[]} - Pôvodný objekt
 * @param {Object | any[]} - Nový objekt
 * @returns {Array} - Rozdiel medzi objektami
 * @example
 * ```javascript
 * import deepCompare from 'utilities/lib/deepCompare';
 * const obj = {
 *  author: {
 *    name: 'Lukáš',
 *    articles: [12, 13],
 *    sections: [1]
 *  }
 * };
 * const modifiedObj = {
 *  author: {
 *    name: 'Igor',
 *    articles: [12, 13, 14]
 *  }
 * };
 * console.log(deepCompare(obj, newObj));
 * //
 * // Typy ovplyvnenia:
 * // 1. M - Modification
 * // 2. A - Addition
 * // 3. R - Removal
 * //
 * // [
 *  // {
 *     // type: 'M',
 *     // path: ['author', 'name'],
 *     // originalContent: 'Lukáš',
 *     // content: 'Igor',
 *   // },
 *   // {
 *     // type: 'A',
 *     // path: ['author', 'articles', 2],
 *     // originalContent: undefined,
 *     // content: 14,
 *   // },
 *   // {
 *     // type: 'R',
 *     // path: ['author', 'sections'],
 *     // originalContent: [1],
 *     // content: undefined,
 *   // },
 * // ];
 * ```
 */


function deepCompare(object, anotherObject) {
  if (typeof object !== typeof anotherObject || Array.isArray(object) !== Array.isArray(anotherObject)) {
    throw 'Types violation. Both arguments must be either arrays or objects.';
  }

  return (Array.isArray(object) && Array.isArray(anotherObject) ? compareArrayItems(object, anotherObject, 'L', []) : compareObjectProperties(object, anotherObject)).concat(Array.isArray(object) && Array.isArray(anotherObject) ? compareArrayItems(anotherObject, object, 'R', []) : compareObjectProperties(anotherObject, object, 'R'));
}

exports.deepCompare = deepCompare;
exports.default = deepCompare;